import { SCORE_TYPE as EVAL_SCORE_TYPE, RESPONSE_TYPE as EVAL_RESPONSE_TYPE } from '../../Recordings/SingleEvaluationForm/evaluationForm.constants'

export { EVAL_SCORE_TYPE as SCORE_TYPE, EVAL_RESPONSE_TYPE as RESPONSE_TYPE }

export const FORM_STATE_FIELDS = {
  IS_DIRTY: 'isDirty',
  IS_PROCESSING: 'isProcessing',
} as const

const FORM_FIELDS = {
  APPROVAL_REQUIRED: 'approvalRequired',
  BAND_RANGES: 'bandRanges',
  CREATED: 'created',
  CREATEDTZ: 'createdTz',
  CREATOR: 'creator',
  DEFAULT_FORM: 'defaultForm',
  DESCRIPTION: 'description',
  HAS_BRANCHING_LOGIC: 'hasBranchingLogic',
  ID: 'id',
  MANUAL_WEIGHTING: 'manualWeighting',
  NAME: 'name',
  RESPONSE_TYPE: 'responseType',
  SCORE_TYPE: 'scoreType',
  SECTIONS: 'sections',
  STATUS: 'status',
  UPDATED: 'updated',
  UPDATEDTZ: 'updatedTz',
  UPDATER: 'updater',
} as const

const SECTION_FIELDS = {
  DISPLAY_ON_LOAD: 'displayOnLoad',
  END_COLOR: 'endColor',
  ID: 'id',
  NAME: 'name',
  ORDER: 'order',
  QUESTIONS: 'questions',
  START_COLOR: 'startColor',
  WEIGHT: 'weight',
} as const

const QUESTION_FIELDS = {
  DESCRIPTION: 'description',
  DISPLAY_ON_LOAD: 'displayOnLoad',
  ID: 'id',
  OPTIONS: 'options',
  ORDER: 'order',
  TEXT: 'text',
  WEIGHT: 'weight',
} as const

const OPTION_FIELDS = {
  DISPLAY_QUESTION: 'displayQuestion',
  DISPLAY_SECTION: 'displaySection',
  ID: 'id',
  ISDEFAULT: 'isDefault',
  KPIPRIORITY: 'kpiPriority',
  LABEL: 'label',
  ORDER: 'order',
  POINTS: 'points',
  TYPE: 'type',
} as const

export const FIELDS = {
  ...FORM_FIELDS,
  ...SECTION_FIELDS,
  ...QUESTION_FIELDS,
  ...OPTION_FIELDS,
} as const

export const FIELD_LENGTHS = {
  NAME: {
    MIN: 1,
    MAX: 64,
  },
  SECTION: {
    NAME: {
      MIN: 1,
      MAX: 64,
    },
  },
  QUESTION: {
    NAME: {
      MIN: 1,
      MAX: 1000,
    },
  },
  ANSWER: {
    NAME: {
      MIN: 1,
      MAX: 64,
    },
  },
} as const

export const ROW_ACTIONS_WIDTH = 200

export const ANSWER_TYPES = [
  {
    id: 1,
    type: 'ADDITIVE',
    translationKey: 'accumulative',
  },
  {
    id: 2,
    type: 'KPI',
    translationKey: 'kpi',
  },
  {
    id: 3,
    type: 'NOTAPPLICABLE',
    translationKey: 'notApplicable',
  },
] as const

export const TABLE_COLUMNS = [
  { label: 'formName', field: FIELDS.NAME, width: 'auto' },
  { label: 'status', field: FIELDS.STATUS, width: 180 },
  { label: 'dateCreated', field: FIELDS.CREATED, width: 180 },
  { label: 'lastUpdated', field: FIELDS.UPDATED, width: 180 },
  { label: 'createdBy', field: FIELDS.CREATOR, width: 180 },
  { label: 'lastUpdatedBy', field: FIELDS.UPDATER, width: 180 },
]

export const KPI_FIELDS = {
  PRIORITY: 'priority',
  QUESTION_NAME: 'questionName',
  ANSWER_NAME: 'answerName',
  FORM_SCORE: 'formScore',
  SECTION_NAME: 'sectionName',
} as const

export const KPI_COLUMNS = [
  { label: 'priority', field: KPI_FIELDS.PRIORITY, width: 'auto' },
  { label: 'question', field: KPI_FIELDS.QUESTION_NAME, width: 'auto' },
  { label: 'answer', field: KPI_FIELDS.ANSWER_NAME, width: 'auto' },
  { label: 'formScore', field: KPI_FIELDS.FORM_SCORE, width: 'auto' },
  { label: 'section', field: KPI_FIELDS.SECTION_NAME, width: 'auto' },
] as const

const FORM_STATUS = {
  DRAFT: 0,
  PUBLISHED: 1,
  ARCHIVED: 2,
} as const

export const EVAL_FORM_STATUS = {
  ...FORM_STATUS,
} as const

export const NEW_EVAL_FORM = {
  id: -1,
  name: '',
  description: '',
  status: FORM_STATUS.DRAFT,
  manualWeighting: false,
  approvalRequired: false,
  bandRanges: [
    {
      band: 1,
      begin: 0,
      end: 40,
    },
    {
      band: 2,
      begin: 40,
      end: 60,
    },
    {
      band: 3,
      begin: 60,
      end: 100,
    },
  ],
  hasBranchingLogic: false,
  responseType: {
    id: EVAL_RESPONSE_TYPE.NONE,
  },
  scoreType: {
    id: EVAL_SCORE_TYPE.PERCENTAGE,
  },
  sections: [],
}

export const SINGLE_ANSWER_DEFAULTS = {
  id: -1,
  type: 'ADDITIVE',
  label: 'New Answer',
  isDefault: false,
  kpiPriority: 0,
  order: 0,
  points: 0,
}

export const CUSTOM_ANSWER_GROUP = {
  id: 1,
  name: 'Create New Answer Group',
  scoringType: null,
  options: [
    {
      ...SINGLE_ANSWER_DEFAULTS,
      isDefault: true,
    },
    {
      ...SINGLE_ANSWER_DEFAULTS,
    },
  ],
}

export const BRANCHING_DEFAULT = {
  NULL: { name: '--',
    section: null,
    question: null },
  QUESTIONS: { name: 'Questions',
    section: 0,
    question: 0 },
  SECTIONS: { name: 'Sections',
    section: 0,
    question: 0 },
} as const
